import { IExportColumnModel } from "../../../../shared/models";

export const CustomConnectionsColumnList: IExportColumnModel[] = [
]